import React, { useEffect, useState } from 'react';
import { useFadeIn } from '../hooks/useFadeIn';
import './Hero.css';

interface HeroProps {
  onLoginClick?: () => void;
  onProductsClick?: () => void;
}

const Hero: React.FC<HeroProps> = ({ onLoginClick, onProductsClick }) => {
  const [shouldAnimate, setShouldAnimate] = useState(false);
  const headlineFadeIn = useFadeIn<HTMLDivElement>({ delay: 0.1, skipInitialCheck: true });

  useEffect(() => {
    requestAnimationFrame(() => {
      setShouldAnimate(true);
    });
  }, []);

  return (
    <section className="hero landing-section">
      <div className="hero-content landing-container">
        <div 
          ref={headlineFadeIn.ref} 
          className={`hero-headline ${shouldAnimate ? 'fade-in-hero' : ''}`}
          style={{ 
            animationDelay: `${headlineFadeIn.delay}s`,
            opacity: shouldAnimate ? undefined : 0
          } as React.CSSProperties}
        >
          <h1>
            Approve profiles <span className="hero-emphasis">faster</span> and grow your community.
          </h1>
          <p className="hero-subtitle">
            AI-native moderation platform for social media and dating app communities.
          </p>
          <div className="hero-cta-row">
            <button className="landing-cta-primary" onClick={onLoginClick}>
              Start Moderating
            </button>
            <button className="landing-cta-secondary" onClick={onProductsClick}>
              View Platform
            </button>
          </div>
        </div>

        <div className={`hero-stage ${shouldAnimate ? 'fade-in-hero' : ''}`}>
          <div className="hero-stage-card">
            <div className="hero-stage-top hero-stage-top-main">
              <p>Moderation Dashboard</p>
              <span className="hero-stage-pill">Live Queue</span>
            </div>
            <div className="hero-stage-grid">
              <div className="hero-stage-panel">
                <h4>Incoming User</h4>
                <ul>
                  <li><span></span>Trust score · 24</li>
                  <li><span></span>Flagged AI-generated photo</li>
                  <li><span></span>Route: auto-reject by policy</li>
                </ul>
              </div>
              <div className="hero-stage-panel">
                <h4>Automation Rate</h4>
                <p>Profiles auto-decided</p>
                <strong>86%</strong>
              </div>
            </div>
            <div className="hero-stage-bottom">
              <div>
                <p>Needs manual review</p>
                <strong>31</strong>
              </div>
              <div>
                <p>Approved today</p>
                <strong>241</strong>
              </div>
              <div>
                <p>Rejected today</p>
                <strong>64</strong>
              </div>
              <div>
                <p>Time saved today</p>
                <strong>3.4 hours</strong>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
